<template>

  
  <div class="row mt-4">
    
    <!-- Gráfico circular -->
    <div class="col-lg-6">
      <div class="card p-3">
        <h5 class="mb-3">Totales de Averías</h5>
        <!-- Filtros de fechas -->
        <div class="row mb-3">
          <div class="col-md-6">
            <label for="fecha_inicio" class="form-label">Fecha inicio</label>
            <input
              id="fecha_inicio"
              type="date"
              class="form-control"
              v-model="fecha_inicio"
            />
          </div>
          <div class="col-md-6">
            <label for="fecha_fin" class="form-label">Fecha fin</label>
            <input
              id="fecha_fin"
              type="date"
              class="form-control"
              v-model="fecha_fin"
            />
          </div>
        </div>
        <canvas id="averiasChart"></canvas>
        <ul class="mt-3">
          <li><strong>Cargue:</strong> {{ totales.averia_cargue }}</li>
          <li><strong>Secado:</strong> {{ totales.averia_secado }}</li>
          <li><strong>Descargue:</strong> {{ totales.averia_descargue }}</li>
        </ul>
      </div>
    </div>

    <!-- Listados -->
    <div class="col-lg-6">
      <div class="card p-3">
        <h5 class="mb-3">Detalle de Averías</h5>
        <!-- Buscador de productos -->
        <div class="mb-3">
          <label for="buscar_producto" class="form-label">Buscar Producto</label>
          <input
            id="buscar_producto"
            type="text"
            class="form-control"
            v-model="buscarProducto"
            placeholder="Escriba el nombre del producto..."
          />
        </div>
        <h6>Cargue</h6>
        <div class="table-responsive">
        <table class="table table-sm">
          <thead>
            <tr>
              <th>Producto</th>
              <th>Horno</th>
              <th>Cargue</th>
              <th>Secado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in filteredCargue" :key="index">
              <td>{{ item.producto ?? '-' }}</td>
              <td>{{ item.horno ?? '-' }}</td>
              <td>{{ item.averia_cargue }}</td>
              <td>{{ item.averia_secado }}</td>
            </tr>
            <tr v-if="filteredCargue.length === 0">
              <td colspan="4" class="text-center text-muted">No se encontraron resultados</td>
            </tr>
          </tbody>
        </table>
        </div>
        
        <!-- Paginación cargue -->
        <div class="d-flex justify-content-between align-items-center mt-2">
          <button class="btn btn-sm btn-secondary" @click="prevPageCargue" :disabled="listados.cargue.current_page === 1">Anterior</button>
          <span>Página {{ listados.cargue.current_page }} de {{ listados.cargue.last_page }}</span>
          <button class="btn btn-sm btn-secondary" @click="nextPageCargue" :disabled="listados.cargue.current_page === listados.cargue.last_page">Siguiente</button>
        </div>

        <h6 class="mt-3">Descargue</h6>
        <div class="table-responsive">
        <table class="table table-sm">
          <thead>
            <tr>
              <th>Producto</th>
              <th>Horno</th>
              <th>Avería Descargue</th>
              <th>Crudo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in filteredDescargue" :key="index">
              <td>{{ item.producto ?? '-' }}</td>
              <td>{{ item.horno ?? '-' }}</td>
              <td>{{ item.averia_descargue }}</td>
              <td>{{ item.averia_crudo }}</td>
            </tr>
            <tr v-if="filteredDescargue.length === 0">
              <td colspan="4" class="text-center text-muted">No se encontraron resultados</td>
            </tr>
          </tbody>
        </table>
        </div>

        <!-- Paginación descargue -->
        <div class="d-flex justify-content-between align-items-center mt-2">
          <button class="btn btn-sm btn-secondary" @click="prevPageDescargue" :disabled="listados.descargue.current_page === 1">Anterior</button>
          <span>Página {{ listados.descargue.current_page }} de {{ listados.descargue.last_page }}</span>
          <button class="btn btn-sm btn-secondary" @click="nextPageDescargue" :disabled="listados.descargue.current_page === listados.descargue.last_page">Siguiente</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
Chart.register(ArcElement, Tooltip, Legend);

export default {
  name: "AveriasChart",
  data() {

    
    const fechaInicio = new Date();
    fechaInicio.setDate(fechaInicio.getDate() - 15);
    const fechaFin= new Date();

    // Convertirlas a formato yyyy-MM-dd (sin UTC)
    const formatDate = (d) => {
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    return {
      fecha_inicio: formatDate(fechaInicio),
      fecha_fin: formatDate(fechaFin),
      buscarProducto: '',
      totales: {
        total_averia_cargue: 0,
        total_averia_secado: 0,
        total_averia_descargue: 0,
      },
      listados: {
        cargue: {
          data: [],
          current_page: 1,
          last_page: 1,
        },
        descargue: {
          data: [],
          current_page: 1,
          last_page: 1,
        },
      },
      chartInstance: null,
    };
  },
  computed: {
    filteredCargue() {
      const data = this.listados.cargue?.data || this.listados.cargue || [];
      if (!this.buscarProducto || this.buscarProducto.trim() === '') {
        return Array.isArray(data) ? data : [];
      }
      const searchTerm = this.buscarProducto.toLowerCase().trim();
      if (!Array.isArray(data)) {
        return [];
      }
      return data.filter(item => {
        const producto = (item?.producto || item?.name || '').toLowerCase();
        return producto.includes(searchTerm);
      });
    },
    filteredDescargue() {
      const data = this.listados.descargue?.data || this.listados.descargue || [];
      if (!this.buscarProducto || this.buscarProducto.trim() === '') {
        return Array.isArray(data) ? data : [];
      }
      const searchTerm = this.buscarProducto.toLowerCase().trim();
      if (!Array.isArray(data)) {
        return [];
      }
      return data.filter(item => {
        const producto = (item?.producto || item?.name || '').toLowerCase();
        return producto.includes(searchTerm);
      });
    },
  },
  watch: {
    fecha_inicio() {
      this.fetchAverias();
    },
    fecha_fin() {
      this.fetchAverias();
    },
  },
  methods: {
    async fetchAverias(pageCargue = 1, pageDescargue = 1) {
      try {

        let params ={
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          page_cargue: pageCargue,
          page_descargue: pageDescargue,
        };
        const res = await this.$store.dispatch('analitycs/getAverias',params); 

        const data = res.data;

        this.totales = data.totales || {};
        this.listados = data.listados || {};

        this.renderChart();
      } catch (error) {
        console.error("Error cargando métricas:", error);
      }
    },
    
    renderChart() {
      if (this.chartInstance) this.chartInstance.destroy();

      const ctx = document.getElementById("averiasChart");

      this.chartInstance = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: ["Cargue", "Secado", "Descargue"],
          datasets: [
            {
              data: [
                this.totales.averia_cargue || 0,
                this.totales.averia_secado || 0,
                this.totales.averia_descargue || 0,
              ],
              backgroundColor: ["#36A2EB", "#FFCE56", "#FF6384"],
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: { position: "bottom" },
          },
        },
      });
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleString("es-ES");
    },
    nextPageCargue() {
      if (this.listados.cargue.current_page < this.listados.cargue.last_page) {
        this.fetchAverias(this.listados.cargue.current_page + 1, this.listados.descargue.current_page);
      }
    },
    prevPageCargue() {
      if (this.listados.cargue.current_page > 1) {
        this.fetchAverias(this.listados.cargue.current_page - 1, this.listados.descargue.current_page);
      }
    },
    nextPageDescargue() {
      if (this.listados.descargue.current_page < this.listados.descargue.last_page) {
        this.fetchAverias(this.listados.cargue.current_page, this.listados.descargue.current_page + 1);
      }
    },
    prevPageDescargue() {
      if (this.listados.descargue.current_page > 1) {
        this.fetchAverias(this.listados.cargue.current_page, this.listados.descargue.current_page - 1);
      }
    },
  },
  mounted() {
    this.fetchAverias();
  },
};
</script>

<style scoped>
.table {
  font-size: 0.85rem;
}
</style>
